import { ICrmSurveyFormQuestion } from "../../../models/response/crm-survey/ICrmSurveyFormQuestion";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objCrmSurveyFormQuestionDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as ICrmSurveyFormQuestion[],
    LOAD_ERROR: "",
    CHANGE_SELECTED_IDS: [] as number[],

};

export const eCrmSurveyFormQuestionActionTypeIds = generateActionTypeIds(objCrmSurveyFormQuestionDefine, "CRM_SURVEY_FORM_QUESTION")
export type ICrmSurveyFormQuestionActionTypes = IGenericActionType<typeof objCrmSurveyFormQuestionDefine, "CRM_SURVEY_FORM_QUESTION">
